module.exports = __webpack_public_path__ + "static/media/changePremium.64b38974.svg";